import { useCallback, useEffect, useRef } from "react";
import { PharmaStpFileModel } from "../../../data-model/nycbsPharmaOrder";
import { makePostCallForNycbsExternal } from "../apis/makePostCallForNycbsExternal";
import { NycbsExternalFilterPayload } from "./useFilterPayload";
import { NycbsExternalTableState } from "../types/nycbsExternalTableState";

export const useFilterAndSearchEffect = (
  filterPayload: NycbsExternalFilterPayload | null,
  initialDataFetchingExecuted: boolean,
  setTableData: React.Dispatch<React.SetStateAction<PharmaStpFileModel[]>>,
  setNycbsExternalState: React.Dispatch<
    React.SetStateAction<NycbsExternalTableState>
  >,
  setPaginationResetCount: React.Dispatch<React.SetStateAction<number>>,
): void => {
  const initialDataFetchingExecutedRef = useRef(initialDataFetchingExecuted);
  const setTableDataRef = useRef(setTableData);
  const setNycbsExternalStateRef = useRef(setNycbsExternalState);
  const setPaginationResetCountRef = useRef(setPaginationResetCount);

  useEffect(() => {
    initialDataFetchingExecutedRef.current = initialDataFetchingExecuted;
    setTableDataRef.current = setTableData;
    setNycbsExternalStateRef.current = setNycbsExternalState;
    setPaginationResetCountRef.current = setPaginationResetCount;
  }, [
    initialDataFetchingExecuted,
    setTableData,
    setNycbsExternalState,
    setPaginationResetCount,
  ]);

  const fetchData = useCallback(() => {
    if (filterPayload) {
      makePostCallForNycbsExternal(
        filterPayload,
        setNycbsExternalStateRef.current,
        setTableDataRef.current,
        setPaginationResetCountRef.current,
      );
    }
  }, [filterPayload]);

  useEffect(() => {
    if (filterPayload && initialDataFetchingExecutedRef.current) {
      fetchData();
    }
  }, [filterPayload, fetchData]);
};
